/* eslint-disable max-len */
import React from "react";
import NewEditIcon from "../../../../components/Icons/NewEditIcon";
import { NotepadIcon } from "../../../../components/Icons";

interface PetReasonEntry {
  petName: string;
  reasons: string[];
  notes?: string;
  petIndex: number;
}

interface ReviewReasonCardProps {
  petReasons: PetReasonEntry[];
  onEditPet: (petIndex: number) => void;
}

export const ReviewReasonCard = ({
  petReasons,
  onEditPet,
}: ReviewReasonCardProps) => {
  const isMultiPet = petReasons.length > 1;

  return (
    <div className="flex flex-col gap-2">
      <p className="font-semibold text-sm text-light-black leading-[14px]">
        {"Reason for Visit"}
      </p>
      {petReasons.map((entry) => {
        const trimmedNotes = entry.notes?.trim();
        return (
          <div
            key={entry.petName}
            className="bg-white border border-taupe-50 rounded-lg p-3"
          >
            <div className="flex gap-2 items-start">
              <NotepadIcon />
              <div className="text-sm text-light-black leading-5 flex-1">
                {isMultiPet && (
                  <p className="text-gray-1 text-xs mb-0.5">
                    {entry.petName}
                  </p>
                )}
                <p>
                  <span className="font-semibold">
                    {"Urgent Visit:"}
                  </span>{" "}
                  {entry.reasons.join(", ")}
                </p>
                {trimmedNotes && (
                  <p className="mt-1 text-gray-1 whitespace-pre-wrap break-words">
                    <span className="font-semibold text-light-black">
                      {"Additional Info:"}
                    </span>{" "}
                    {trimmedNotes}
                  </p>
                )}
              </div>
              <div
                className="cursor-pointer ml-2 shrink-0"
                onClick={() => onEditPet(entry.petIndex)}
              >
                <NewEditIcon width={20} height={20} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
